import React, {Component, Fragment} from 'react';
import DashboardTopEntry from "./DashboardTopEntry";
import DashboardInflow from "./DashboardInflow";
import DashboardKeyword from "./DashboardKeyword";

class DashboardCurrent extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Fragment>
        <h4 className="tit_cont">최근 7일 통계</h4>
        <div className="wrap_box wrap_box_type1">
          <DashboardTopEntry/>
          <DashboardInflow/>
          <DashboardKeyword/>
        </div>
      </Fragment>
    );
  }
}
export default DashboardCurrent;
